import React from 'react'
import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/ShowtimesView/components/TheatricalPromotionContext'
import { ShopifyGroupTicketsLastRodeo } from '@/views/TicketCheckoutViews/ShowtimesView/components/modals/GroupTicketsModal/ShopifyGroupTicketsLastRodeo'

interface Props {
  ticketPrice: number
  theatricalSlug: string
  groupTicketProductVariantId: string
}

export const LastRodeoModal: React.FC<Props> = ({ ticketPrice, theatricalSlug, groupTicketProductVariantId }) => {
  const { experiments } = useTheatricalPromotionContext()
  const isLastRodeoGroupExp = experiments ? experiments['last-rodeo-group-tickets'] : undefined
  const expImageSrc = isLastRodeoGroupExp
    ? 'https://images.angelstudios.com/image/upload/v1744418920/the-last-rodeo/Neal_Cutout.png'
    : 'https://images.angelstudios.com/image/upload/v1744414123/the-last-rodeo/c7e2723c7531a72aae7c582e953f3f7b.png'

  return (
    <ShopifyGroupTicketsLastRodeo
      ticketPrice={ticketPrice}
      theatricalSlug={theatricalSlug}
      groupTicketProductVariantId={groupTicketProductVariantId}
      expImageSrc={expImageSrc}
      discountRates={[
        { quantity: 4, discountRate: 0.6 },
        { quantity: 5, discountRate: 0.6 },
        { quantity: 6, discountRate: 0.5 },
      ]}
    />
  )
}
